// Configuration for API URL
// In development (local), this falls back to localhost:5001
// In production, VITE_API_URL should be set in the build environment (GitHub Actions)
let apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5001';

// Ensure proper protocol prefix
if (apiUrl && !apiUrl.startsWith('http')) {
    apiUrl = `http://${apiUrl}`;
}

// Fix mixed content: if page is HTTPS, API must also be HTTPS
// BUT: In development, we usually want to keep HTTP for localhost
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && !apiUrl.includes('localhost')) {
    apiUrl = apiUrl.replace(/^http:/, 'https:');
}

// Log API URL in development for debugging
if (import.meta.env.DEV && typeof window !== 'undefined') {
    console.log('🔧 API_URL configurada:', apiUrl);
    console.log('🔧 Window location:', window.location.href);
    console.log('🔧 VITE_API_URL env:', import.meta.env.VITE_API_URL);
}

export const API_URL = apiUrl;
